import * as React from 'react';
import { CardEvent } from 'src/store/events/types';
import { formatDate } from 'src/utils/dateHelper';
import { AvailabilityDots } from 'src/components/Week/Event/AvailabilityDots/AvailabilitsDots';
import { calculateActive } from 'src/components/Week/Event/Event';
import { Link } from 'react-router-dom';
import { getSectionString } from 'src/utils/sharedHelpers';

import './EventsDaily.scss';

interface Props {
  key: number;
  event: CardEvent;
}

const EventsDailyItem: React.SFC<Props> = ({ key, event }: Props) => (
  <li
    key={key}
    className="border bottom"
    style={{ textAlign: 'left', paddingBottom: '20px', marginBottom: '20px' }}
  >
    <div>
      <Link to={`/section/${getSectionString(event)}/${event.id}`}>
        <h3 className={event.hidden ? 'isHidden' : ''} style={{ textAlign: 'left' }}>
          {event.title}
        </h3>
      </Link>
    </div>
    <div style={{ lineHeight: '0' }}>
      <span style={{ display: 'inline-block', marginRight: '10px' }}>
        {formatDate(event.begins, 'HH:mm')} Uhr
      </span>
      <AvailabilityDots
        style={{ display: 'inline-block', marginRight: '10px' }}
        active={calculateActive(event.quota, event.bookedBy)}
        hidden={event.hidden}
      />
      <span style={{ textTransform: 'uppercase' }}>
        <Link className="rollOverBlue" to={`/section/${getSectionString(event)}/${event.id}`}>
          Detail & Anmeldung
        </Link>
      </span>
    </div>
  </li>
);

export default EventsDailyItem;



// WEBPACK FOOTER //
// ./src/components/Event/EventsDaily/EventsDailyItem/EventsDailyItem.tsx